var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStackCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#A2ADB6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6461 15.4813L19.4189 12.0958C19.5471 12.0408 19.6851 12.0121 19.8246 12.0113C19.9642 12.0105 20.1025 12.0376 20.2314 12.0911C20.3602 12.1446 20.4771 12.2233 20.5751 12.3227C20.6731 12.4221 20.7501 12.54 20.8018 12.6697L26.1637 25.6301C26.2751 25.8929 26.2789 26.1889 26.1742 26.4545C26.0695 26.7201 25.8648 26.9339 25.604 27.05L17.8323 30.4355C17.704 30.4906 17.5659 30.5195 17.4263 30.5204C17.2866 30.5213 17.1482 30.4942 17.0192 30.4407C16.8901 30.3872 16.7732 30.3084 16.6751 30.2089C16.5771 30.1095 16.4999 29.9914 16.4483 29.8616L11.0864 16.9002C10.975 16.6373 10.9712 16.3413 11.0759 16.0757C11.1805 15.8101 11.3853 15.5974 11.6461 15.4813Z",
    stroke: "#0059A7",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0555 12H25.1444C25.4332 12 25.7102 12.1147 25.9144 12.3189C26.1186 12.5232 26.2334 12.8001 26.2334 13.0889V16.9002",
    stroke: "#0059A7",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5001 14.1779C29.7876 14.2998 30.0664 14.4142 30.3364 14.5209C30.6023 14.6337 30.8124 14.8474 30.9206 15.1151C31.0288 15.3829 31.0263 15.6826 30.9136 15.9484L28.4112 21.8003",
    stroke: "#0059A7",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackCards);
export default __webpack_public_path__ + "static/media/stack-cards.b007cc7613fd0b9432a1ee8308a6a600.svg";
export { ForwardRef as ReactComponent };